import { AttributeValue } from 'app/components/attributes/attributes.model';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {HttpClient} from '@angular/common/http';
import {Instrument} from '../../interfaces/interfaces';

// import { FuseUtils } from '@fuse/utils';

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/');
}

export class Type
{
    id: number;
    name: string;
    type: string;

    constructor(type?)
    {
        type = type || {};
        this.id = type.id || 0;
        this.name = type.name;
        this.type = type.type;

    }
}

export class Entity
{
    id: number;
    name: string;
    type: Type;
    enabled: boolean;


    constructor(entity?)
    {
        entity = entity || {};
        this.id = entity.id || 0;
        this.name = entity.name;
        //this.type = typeof entity.type === 'string' ? null : entity.type;
        this.type = entity.type;
        this.enabled = entity.enabled !== undefined ? entity.enabled : true;

    }
}


export class YPMComment extends Entity{
    description: string;
    createdBy: Entity;
    creationDate: Date;
}


export class ApprovableEntity extends Entity{
    approved: boolean;
    approvedDate: Date;
    approvedBy: Entity;
    inCharge: Entity;
    participants: Entity[];
    comments: YPMComment[];
}

export class EstimationRole {
    id: number;
    roleId: number;
    estimatedHH: number;
    hourIncome: number;
}

export class ProjectGroup extends Entity {
    creationDate: Date;
    // handle: string;
    description: string;
    type: Type;
    createdBy: Entity;
    inCharge: Entity;
    start: Date;
    finish: Date;
    estimatedHH: number;
    actualHH: number;
    estimatedHHCost: number;
    actualHHCost: number;
    income: number;
    internalCost: number;
    actualCost: number;
    progress: number;
    approved: string;
    approvedDate: Date;
    approvedBy: Entity;
    estimations: EstimationRole[];
    estimationChanged: boolean;


    constructor(product?)
    {
        super(product);
        this.createdBy = product.createdBy;
        this.inCharge = product.inCharge;
        this.start = product.start;
        this.finish = product.finish;
        this.estimatedHH = product.estimatedHH || 0;
        this.actualHH = product.actualHH || 0;
        this.estimatedHHCost = product.estimatedHHCost || 0;
        this.actualHHCost = product.actualHHCost || 0;
        this.income = product.income || 0;
        this.internalCost = product.internalCost || 0;
        this.actualCost = product.actualCost || 0;
        this.progress = product.progress || 0;
        this.approved = product.approved;
        this.approvedDate = product.approvedDate;
        this.approvedBy = product.approvedBy;
        this.description = product.description;
        this.creationDate = product.creationDate;
        this.estimations = product.estimations;
    }


    get difHH(): number{
        return this.estimatedHH - this.actualHH;
    }

    set difHH(_difHH){

    }

    get difHHCost(): number{
        return this.estimatedHHCost - this.actualHHCost;
    }

    set difHHCost(_difHHCost){

    }

}



export class Project extends ProjectGroup
{
    
    area: string;
    projectNumber: number;
    status: string;
    attributes: AttributeValue[];
    active: boolean;
    instrument?: Instrument;
    client: Entity;
    team: Entity;

    

    /**
     * Constructor
     *
     * @param product
     */
    constructor(product?)
    {
        product = product || {};
        super(product);
        this.area = product.area ;

        this.projectNumber = product.projectNumber || 0;
        this.status = product.status ;
        this.createdBy = product.createdBy;
        this.team = product.team;
        this.type = product.type;
        this.client = product.client;
        this.instrument = product.instrument;


    }




}
